import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import { Calendars } from "../../../components/Calendar/Calendar";
import { Loading } from "../../../components/Loading/Loading";
import { DialogConfirm, DialogDelete, DialogViewPicBase64 } from "../../../components/DialogService/DialogService";
import { useHistory } from "react-router-dom";
import { dataUserSession } from "../../../utilities/dataSession";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { formatDateAPI } from "../../../utilities/DateUtil";
import { FooterButtonCenter, FooterButtonSigle } from "../../../components/FooterButton/FooterButton";
import { DialogOpenReport } from "../../../components/DialogService/DialogService";
import { deCodeBase64_2 } from "../../../components/UploadPic/UploadPicUtil";
import { srcFile } from "../../../utilities/FileUtil";

//SERVICE
import { pSupervisorWarningLetterUpdate } from "../../../service/200/P216Service";
import { genGetBranchInfo } from "../../../service/GEN/GenService";
import { commonUpload } from "../../../service/APP/AppService";

// PAGE
import P216Dialog from "./P216Dialog";

export default function P216Edit() {
    const history = useHistory();
    const toast = useRef(null);
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    //Data
    const [dataForm, setDataForm] = useState({ action: "", attachmentPathName: "", go: "", warningDate: new Date(), warningTopic: "", warningNo: "", warningLetterNo: "", issuerName: "", contractorName: "" });
    const [pathPic, setPathPic] = useState("");

    //report
    const [dialogPDF, setDialogPDF] = useState(false);

    // Dialog
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => {},
        onCancle: () => {},
        footerBtn: () => {},
    });

    // PIC
    const [dialogUpload, setDialogUpload] = useState({ dialog: false, show: false });
    const [dataFile, setDataFile] = useState(null);

    // View Pic
    const [dialogPic, setDialogPic] = useState({ dialog: false, pic: "", show: false });

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state) {
                setDataForm({ ...dataForm, ...history.location.state.dataObject.data, routeNo: history.location.state.dataObject.data.routeNo === undefined ? 0 : history.location.state.dataObject.data.routeNo, userId: dataUserSession().userId });
            } else {
                page("216");
            }
        } else {
            page("login");
        }
    }, []);

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };
    const validation = (object) => {
        if (object.warningDate === "" || object.warningTopic === "" || object.issuerName === "") {
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };
    const submitForm = (act) => {
        if (validation(dataForm)) {
            setLoading(true);
            const req = {
                actionCode: act,
                attachmentPathName: pathPic === "" ? dataForm.attachmentPathName : pathPic,
                contractNo: setValViewForm("contractNo"),
                issuerName: setValViewForm("issuerName") === undefined ? "" : setValViewForm("issuerName"),
                remark: setValViewForm("remark") === undefined ? "" : setValViewForm("remark"),
                routeNo: dataForm.routeNo,
                userId: dataForm.userId,
                warningDate: formatDateAPI(dataForm.warningDate),
                warningLetterNo: dataForm.warningLetterNo === undefined ? "" : dataForm.warningLetterNo,
                warningNo: dataForm.warningNo === undefined ? "" : dataForm.warningNo,
                warningTopic: dataForm.warningTopic === undefined ? "" : dataForm.warningTopic,
            };
            pSupervisorWarningLetterUpdate(req).then(
                (res) => {
                    setLoading(false);
                    if (res !== undefined) {
                        setdialogOption({
                            ...dialogOption,
                            header: res[0].statusCode === "C" ? "บันทึกสมบูรณ์" : "มีข้อผิดพลาด",
                            content: res[0].statusText,
                            footerBtn: () => footerButtonSingle(),
                        });
                        setConfirmDialog({ open: true });
                    } else {
                        showMessages("error", "เกิดข้อผิดพลาด", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                    }
                },
                function (err) {
                    if (err.response && err.response.data.status === 401) {
                        alert(JSON.stringify("เนื่องจาก Authorized หมดอายุ กรุณาเข้าสู่ระบบใหม่"));
                        window.location.href = "/login";
                    }
                    setLoading(false);
                }
            );
        }
    };

    const onGenGetBranchInfo = () => {
        setLoading(true);
        const req = {
            orderNo: "",
            requestNo: dataForm.contractNo,
            userId: dataForm.userId,
        };
        genGetBranchInfo(req).then(
            (res) => {
                setLoading(false);
                if (res !== undefined) {
                    onUploadPic(res[0]);
                } else {
                    showMessages("error", "เกิดข้อผิดพลาด", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                }
            },
            function (err) {
                if (err.response && err.response.data.status === 401) {
                    alert(JSON.stringify("เนื่องจาก Authorized หมดอายุ กรุณาเข้าสู่ระบบใหม่"));
                    window.location.href = "/login";
                }
                setLoading(false);
            }
        );
    };
    const onUploadPic = (obj) => {
        setLoading(true);
        const repFileName = dataFile.fileUpload.fileName.replace(/\.[^/.]+$/, "");
        const req = {
            base64Pic: deCodeBase64_2(dataFile.fileUpload),
            branchId: obj.branchCode,
            fiscalYear: obj.fiscalYear,
            orderNo: "",
            picName: repFileName,
            requestNo: dataForm.contractNo.replace("-", ""),
            userId: dataForm.userId,
            picType: dataFile.fileUpload.typefile,
        };
        commonUpload(req).then(
            (res) => {
                setLoading(false);
                setPathPic(res.picPath);
                setdialogOption({
                    ...dialogOption,
                    header: "",
                    content: res.status === "Success" ? "บันทึกรูปภาพสำเร็จ" : "บันทึกรูปภาพไม่สำเร็จ",
                    footerBtn: () => footerButtonUploadPic(),
                });
                setConfirmDialog({ open: true });
                if (res !== undefined) {
                } else {
                    showMessages("error", "เกิดข้อผิดพลาด1", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                }
            },
            function (err) {
                if (err.response && err.response.data.status === 401) {
                    alert(JSON.stringify("เนื่องจาก Authorized หมดอายุ กรุณาเข้าสู่ระบบใหม่"));
                    window.location.href = "/login";
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด2 : ${err} `, "");
                }
                setLoading(false);
            }
        );
    };

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setDataForm({
            ...dataForm,
            [`${key}`]: val,
        });
    };

    const setValViewForm = (key) => {
        return dataForm[key];
    };

    const page = (_page) => {
        switch (_page) {
            case "login":
                history.push("/login");
                break;
            case "216":
                history.push({
                    pathname: "/216",
                    state: { contractNo: dataForm.contractNo, routeNo: dataForm.routeNo, contractorName: dataForm.contractorName },
                });
                break;

            default:
                break;
        }
    };

    const footerButton = () => {
        const onDeleteData = () => {
            submitForm("D");
        };
        return <FooterButtonCenter onClickOk={() => onDeleteData()} onClickCancle={() => setDeleteDialog(false)} />;
    };

    const footerButtonSingle = () => {
        return <FooterButtonSigle btnLabel="ปิด" onClick={() => page("216")} />;
    };
    const footerButtonUploadPic = () => {
        return <FooterButtonSigle btnLabel="ปิด" onClick={() => setConfirmDialog(false)} />;
    };

    const handlerOnSavePic = () => {
        onGenGetBranchInfo();
        setDialogUpload({ dialog: false, show: false });
    };

    const handlerPicPath = (key) => {
        const _s = dataForm.attachmentPathName === "" ? "" : dataForm.attachmentPathName.split("/").pop();
        if (key == "namepic" && dataFile !== null) {
            if (dataFile.fileUpload !== null) return dataFile === null ? _s : dataFile.fileUpload.fileName;
        }
        if (key == "image" && dataFile !== null) return dataFile.fileUpload.base64String;
    };

    const handlerViewFile = (act) => {
        function isImage(url) {
            return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
        }
        function isPDF(url) {
            return /\.(pdf)$/.test(url);
        }

        if (act !== undefined && handlerPicPath("namepic") === undefined) {
            const _o = srcFile(dataForm.attachmentPathName);
            if (isImage(_o.src)) {
                setDialogPic({
                    dialog: true,
                    show: true,
                    pic: _o.src,
                });
            } else {
                if (isPDF(_o.src)) {
                    window.open(_o.src);
                    // setDialogPDF({ open: true, pdfURL: _o.src });
                } else {
                    window.open(_o.src);
                }
            }
        } else {
            if (dataFile.fileUpload.typefile !== "jpg") {
                if (dataFile.fileUpload.typefile === "pdf") {
                    // setDialogPDF({ open: true, pdfURL: dataFile.fileUpload.base64String });
                    window.open(dataFile.fileUpload.base64String);
                } else {
                    // setDialogPDF({ open: true, pdfURL: dataFile.fileUpload.base64String });
                    window.open(dataFile.fileUpload.base64String);
                }
            } else {
                setDialogPic({
                    dialog: true,
                    show: true,
                    pic: handlerPicPath("image"),
                });
            }
        }
    };

    const handlerGetNnmeUrl = (url) => {
        return url.split("/").pop();
    };

    return (
        <>
            <Loading loading={loading} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">รายละเอียดใบแจ้งเตือน</h2>
                        <hr /> */}
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-2"></div>
                            <div className="p-col-12 p-md-8">
                                <div className="p-grid p-fluid">
                                    <div className="p-col-12 p-md-6">
                                        <label>เลขที่สัญญา</label>
                                        <div className="p-inputgroup">
                                            <InputText id="contractNo" value={setValViewForm("contractNo")} maxLength={20} disabled={true} />
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label>บริษัท</label>
                                        <div className="p-inputgroup">
                                            <InputText id="contractorName" value={setValViewForm("contractorName")} maxLength={200} disabled={true} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-2"></div>
                        </div>
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-2"></div>
                            <div className="p-col-12 p-md-8">
                                <hr />
                            </div>
                        </div>
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-2"></div>
                            <div className="p-col-12 p-md-8">
                                <div className="p-grid p-fluid">
                                    <div className="p-col-12 p-md-6">
                                        <label>แจ้งเตือนครั้งที่</label>
                                        <div className="p-inputgroup">
                                            <InputText id="warningNo" value={setValViewForm("warningNo")} maxLength={20} disabled={true} />
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label>เลขที่หนังสือแจ้งเตือน</label>
                                        <div className="p-inputgroup">
                                            <InputText id="warningLetterNo" value={setValViewForm("warningLetterNo")} onChange={(e) => onInputTextChange(e, "warningLetterNo")} maxLength={50} disabled={true} />
                                        </div>
                                        {/* {submitted && !setValViewForm("warningLetterNo") && validateInputText("warningLetterNo", "เลขหนังสือแจ้งเตือน")} */}
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-2"></div>
                        </div>
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-2"></div>
                            <div className="p-col-12 p-md-8">
                                <div className="p-grid p-fluid">
                                    <div className="p-col-12 p-md-6">
                                        <label>วันที่แจ้งเตือน</label>
                                        <div className="p-inputgroup">
                                            <Calendars id="warningDate" className="p-invalid" value={new Date(setValViewForm("warningDate"))} onChange={(e) => onInputTextChange(e, "warningDate")} />
                                        </div>
                                        {submitted && !setValViewForm("warningDate") && validateInputText("warningDate", "วันที่แจ้งเตือน")}
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label>เรื่อง</label>
                                        <span style={{ color: "red" }}>*</span>
                                        <div className="p-inputgroup">
                                            <InputText id="warningTopic" value={setValViewForm("warningTopic")} onChange={(e) => onInputTextChange(e, "warningTopic")} />
                                        </div>
                                        {submitted && !setValViewForm("warningTopic") && validateInputText("warningTopic", "เรื่อง")}
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-2"></div>
                        </div>
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-2"></div>
                            <div className="p-col-12 p-md-8">
                                <div className="p-grid p-fluid">
                                    <div className="p-col-12 p-md-6">
                                        <label>ผู้แจ้ง</label>
                                        <span style={{ color: "red" }}>*</span>
                                        <div className="p-inputgroup">
                                            <InputText id="issuerName" value={setValViewForm("issuerName")} onChange={(e) => onInputTextChange(e, "issuerName")} maxLength={200} />
                                        </div>
                                        {submitted && !setValViewForm("issuerName") && validateInputText("issuerName", "ผู้แจ้ง")}
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label>หมายเหตุ</label>
                                        <div className="p-inputgroup">
                                            <InputText id="remark" value={setValViewForm("remark")} onChange={(e) => onInputTextChange(e, "remark")} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-2"></div>
                        </div>

                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-2"></div>
                            <div className="p-col-12 p-md-8">
                                <div className="p-grid p-fluid">
                                    <div className="p-col-12 p-md-2">
                                        <label>เเนบไฟล์</label>
                                        <Button className="p-button p-button-success p-mr-2 p-mb-2" icon="pi pi-plus" label="เเนบรูปภาพ" onClick={() => setDialogUpload({ dialog: true, show: true })} />
                                    </div>
                                    <div className="p-col-12 p-md-3" style={{ paddingTop: 35 }}>
                                        <label onClick={() => handlerViewFile("SAVE")}>{handlerPicPath("namepic") === undefined ? handlerGetNnmeUrl(dataForm.attachmentPathName) : handlerPicPath("namepic")}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-2"></div>
                        </div>
                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <Button className="p-button p-button-success p-mr-2 p-mb-2" icon="pi pi-save" label="บันทึก" style={{ width: 170 }} onClick={() => submitForm(dataForm.go === "NEW" ? "A" : "U")} />
                                <Button
                                    className="p-button-secondary p-button p-mr-2 p-mb-2"
                                    icon="pi pi-arrow-left"
                                    label="กลับหน้าจอหลัก"
                                    // style={{ marginLeft: '5px' }}
                                    style={{ width: 170, marginLeft: "5px" }}
                                    onClick={() => page("216")}
                                />
                                <Button className="p-button-danger p-button p-mr-2 p-mb-2" icon="pi pi-trash" label="ลบรายการ" style={{ width: 170 }} onClick={() => setDeleteDialog({ open: true })} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DialogViewPicBase64 dialog={dialogPic} data={dialogPic.pic} modal setDialogPic={setDialogPic} />
            <DialogDelete visible={deleteDialog.open} header="การยืนยัน" modal footer={footerButton()} onHide={() => setDeleteDialog(false)} textContent="คุณต้องการลบข้อมูล ใช่หรือไม่?" />
            <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
            <P216Dialog dialog={dialogUpload} setDialog={setDialogUpload} dataFile={dataFile} setDataFile={setDataFile} typeFile="jpg" onSaveFile={handlerOnSavePic} />
            <DialogOpenReport header="พิมพ์ใบสั่งสนาม" dialog={dialogPDF} setDialog={setDialogPDF} />
        </>
    );
}
